import React, { Component } from "react";
import PropTypes from "prop-types";

class VolumeMeter extends Component {
  state = { clipped: false };

  canvas = React.createRef();
  colors = {
    backgroud: "rgb(0, 0, 0)",
    grey: "rgb(50, 50, 50)",
    green: "rgb(50, 255, 50)",
    yellow: "rgb(200, 200, 50)",
    red: "rgb(255, 50, 50)",
  };
  yellowLvl = 0.7;
  redLvl = 0.97;
  bars = [];

  componentDidMount() {
    const { numBars } = this.props;
    for (let i = 0; i < numBars; i++) {
      this.bars.push({
        color: this.colors.grey,
        lastTimeYellow: null,
      });
    }
  }

  componentDidUpdate() {
    this.draw();
  }

  draw = () => {
    // init variables
    const { maxVol, numBars } = this.props;
    let { clipped } = this.state;
    const canvas = this.canvas.current;
    if (!canvas) return;
    const height = canvas.height;
    const width = canvas.width;
    const ctx = canvas.getContext("2d");

    // background
    ctx.beginPath();
    ctx.fillStyle = "black";
    ctx.fillRect(0, 0, width, height);

    // bars
    const spaceHeight = height * 0.01;
    const clippingBarHeight = height * 0.1;
    const barHeight =
      (height - clippingBarHeight - spaceHeight * (numBars + 2)) / numBars;
    const barOffset = width * 0.05;
    const barWidth = width - barOffset * 2;
    this.bars.forEach((bar, i) => {
      ctx.beginPath();
      const currLvl = i / numBars;
      const barStartY = (i + 1) * (spaceHeight + barHeight);
      let color = bar.color;
      if (maxVol !== -1) {
        if (currLvl < maxVol) {
          if (currLvl < this.yellowLvl) color = this.colors.green;
          else {
            color = this.colors.yellow;
            bar.lastTimeYellow = new Date();
          }
        }
        if (bar.lastTimeYellow && new Date() - bar.lastTimeYellow < 500) {
          color = this.colors.yellow;
        }
      }
      ctx.fillStyle = color;
      ctx.fillRect(barOffset, height - barStartY, barWidth, barHeight);
    });

    // clipping bar
    ctx.beginPath();
    if (clipped && maxVol === -1) {
      clipped = false;
      this.setState({ clipped });
    } else if (!clipped && maxVol >= this.redLvl) {
      clipped = true;
      this.setState({ clipped });
    }
    ctx.fillStyle = clipped ? this.colors.red : this.colors.grey;
    ctx.fillRect(barOffset, spaceHeight, barWidth, clippingBarHeight);
  };

  render() {
    const { width, height } = this.props;
    return <canvas width={width} height={height} ref={this.canvas} />;
  }
}

VolumeMeter.propTypes = {
  maxVol: PropTypes.number.isRequired,
  width: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
  numBars: PropTypes.number.isRequired,
};

export default VolumeMeter;
